/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { warning_message } from "../../../../components/alerte/AlerteMessage";
import Loader from "../../../../components/loading/Loader";
import Icon from "../../../../components/obligatoire/Icon";
import { getParamTechByCategorie } from "../../../../services/paramtech/paramTechAPI";
import { numberWithSpaces } from "../../../../utils/SessionUtiles";
import { calculResultRetraite } from "./RetraiteFunction";

export default function DevisRetraite({ categorie_id, t }) {
  const { id, title, type } = useParams("");
  // SHOW RESULT OF PRIME total AFTER INPUT INFO
  const [show, setshow] = useState(false);
  // ---------------USE FORM ELEMENTS ----------
  const { register, handleSubmit } = useForm(); //FORM DATA
  // Results
  const [results, setResults] = useState({
    capitalacquis: 0, // Capital garenti
    rente: 0, // RENTRE annuelle equivalente certaine service
  });
  //OBJET des parametres techniques selon la catégorie (with id categorie dans les params)
  const [paramTech, setparamTech] = useState({});
  //Fact d'actualisation pour la formule du commutateur
  const [fraisActualisation, setfraisActualisation] = useState(0);
  // Taux technique pour la formule du commutateur
  const [tauxTech, settauxTech] = useState(0);
  // LOADER OF RESULTS
  const [loaderResult, setloaderResult] = useState(false);

  useEffect(() => {
    getParamTechByCategorie(categorie_id)
      .then((result) => {
        if (result?.data?.code === 200) {
          var data = result?.data?.data[0];
          setparamTech(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function onFormSubmit(dataRes) {
    setshow(true);
    setloaderResult(false);
    var { prime_commercial, periodicite, durre_rente, duree_contrat } = dataRes;

    if (parseInt(durre_rente) > 5 || parseInt(durre_rente) < 0) {
      warning_message(t("La durée de la rente doit être inférieur à 5 ans !"))
    } else {
      var obj = calculResultRetraite(
        prime_commercial,
        periodicite,
        duree_contrat,
        durre_rente,
        paramTech
      );
      setResults({
        capitalacquis: obj?.capital_acquis,
        rente: obj?.total_rente,
      });
      setloaderResult(false);
    }
  }

  return (
    <div>
      <h5 className="mt-4 mb-4 text-center"> {t("Devis Retraite")} </h5>
      <div className="text-center">
        <img
          className="mb-4 text-center"
          src="../img/bg-img/21.png"
          width={"100px"}
          alt="Assurance vie"
        />
      </div>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="form-group mb-3">
          <label className="form-label fz-12">
            {t("Prime Commerciale")} <Icon />
          </label>
          <input
            className="form-control fz-12"
            type="text"
            placeholder="Prime ..."
            {...register("prime_commercial")}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label fz-12">
            {t("Periodicité")} <Icon />
          </label>
          <select className="form-select  fz-12" {...register("periodicite")}>
            <option value={""}>{t("Choisir")} </option>
            <option value={1}>{t("Annuelle")}</option>
            <option value={2}>{t("Semestrielle")}</option>
            <option value={4}>{t("Trimistrielle")}</option>
            <option value={12}>{t("Mensuelle")}</option>
          </select>
        </div>
        <div className="form-group mb-3">
          <label className="form-label fz-12">
            {t("Durée de service de la rente (année)")} <Icon />
          </label>
          <input
            className="form-control  fz-12"
            type="number"
            placeholder="Durée de la rente .."
            {...register("durre_rente")}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label fz-12">
            {t("Durée du contrat (année)")} <Icon />
          </label>
          <input
            className="form-control  fz-12"
            type="text"
            placeholder="Cotisiation ..."
            {...register("duree_contrat")}
            required
          />
        </div>
        <div className="row">
          <div className=" mt-3">
            <button type="submit" className="btn btn-purple col-12  fz-12">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-calculator me-2"
                viewBox="0 0 16 16"
              >
                <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z" />
                <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z" />
              </svg>
              {t("Calculer")}
            </button>
          </div>
        </div>
        {show && (
          <div className="card mb-4 ">
            <div className="card-body">
              <h5 className="text-center"> {t("Total du calcul")} </h5>
              <table className="table  mb-0 table-striped-primary mt-3">
                {loaderResult ? (
                  <Loader />
                ) : (
                  <tbody>
                    <tr>
                      <td>{t("Capital Acquis")}</td>
                      <td>
                        {numberWithSpaces(Math.round(results?.capitalacquis))}
                      </td>
                    </tr>

                    <tr>
                      <td>{t("Rente certaine service")}</td>
                      <td> {numberWithSpaces(Math.round(results?.rente))} </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
            <div className="row">
              <div className="col-12">
                <div className=" float-end">
                  <a
                    href={
                      "facturation_produits/id=" +
                      id +
                      "&title=" +
                      title +
                      "&type=" +
                      type
                    }
                    className="btn btn-success col-12 fz-12 mt-3 mb-3"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      fill="currentColor"
                      className="bi bi-receipt me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z" />
                      <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z" />
                    </svg>
                    {t("Souscrire")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}
